import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Campus, Home, Login, Loading, Search, Navbar, Message, Calendars, Types, Places, Profile, Events, Details, Students, Student, Teacher, TeacherDetails, RegisterCSV, Areas, Accounts, Careers, Departments, Staff, StaffEvents, Thematics, Modalities, Ods, Supervision } from "./components";
import { ReportOne, ReportTwo, ReportThree, ReportFour, ReportFive, ReportSix, EventsByYear, ReportAttendance, ReportStudents, ReportSeven } from "./components/Reports";
import { Authenticated, Root, Coordi, RootBoss, RootCoordi, RootSupervisor } from "./components/ProtectedRoutes";
import { PageNotFound, SinglePost } from "./components/Tools";
import { clearAlert } from "./features/alert/alertSlice";
import { useDispatch } from "react-redux";
import moment from 'moment';
import 'moment/locale/es';
moment.locale('es');

const App = () => { 
    const dispatch = useDispatch();
    const handleClose = (event, reason) => {
        if(reason === 'clickaway') return;
        dispatch(clearAlert())
    }
    return(
        <BrowserRouter>
            <Navbar />
            <Message handleClose={handleClose} />
            <Loading />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/buscar" element={<Search />} />
                <Route path="/registro/evento/:id" element={<SinglePost />} />
                <Route element={<Authenticated />}>
                    <Route path="/perfil" element={<Profile />} />
                    <Route path='/eventos' element={<Events />} />
                    <Route path="/eventos/:id" element={<Details />} />
                    <Route path="/eventos/reporte" element={<ReportAttendance />} />
                    <Route path="/eventos/reporte/general" element={<EventsByYear />} />
                    <Route element={<RootBoss />}>
                        <Route path="/profesores" element={<Teacher />} />
                        <Route path="/profesores/:id" element={<TeacherDetails />} />
                    </Route>
                    <Route element={<RootCoordi />}>
                        <Route path="/estudiantes" element={<Students />} />
                        <Route path="/estudiantes/:id" element={<Student />} />
                    </Route>
                    <Route element={<RootSupervisor />}>
                        <Route path="/reporte/asistencia" element={<ReportTwo />} />
                        <Route path="/reporte/asistencia/alumnos" element={<ReportFour />} />
                        <Route path="/reporte/asistencia/sexo" element={<ReportOne />} />
                        <Route path="/reporte/asistencia/personal" element={<ReportFive />} />
                        <Route path="/reporte/ods" element={<ReportThree />} />
                        <Route path="/reporte/total/eventos" element={<ReportSix />} />
                        <Route path="/reporte/eventos-alumnos" element={<ReportSeven />} />
                    </Route>
                    <Route element={<Root />}>
                        <Route path="/areas" element={<Areas />} />
                        <Route path="/cuentas" element={<Accounts />} />
                        <Route path="/carreras" element={<Careers />} />
                        <Route path="/sedes" element={<Campus />} />
                        <Route path="/administrativos" element={<Staff />} />
                        <Route path="/administrativos/:id" element={<StaffEvents />} />
                        <Route path="/calendarios" element={<Calendars />} />
                        <Route path="/departamentos" element={<Departments />} />
                        <Route path="/lugares" element={<Places />} />
                        <Route path="/tipos" element={<Types />} />
                        <Route path="/csv" element={<RegisterCSV />} />
                        <Route path="/supervision" element={<Supervision />} />
                        <Route path="/tematicas" element={<Thematics />} />
                        <Route path="/modalidades" element={<Modalities />} />
                        <Route path="/ods" element={<Ods />} />
                    </Route>
                    <Route element={<Coordi />}>
                        <Route path="/estudiantes/reporte" element={<ReportStudents />} />
                    </Route>
                </Route>
                <Route path="*" element={<PageNotFound />} />
            </Routes>
        </BrowserRouter>
    )
}

export default App;